import {
  Tag,
  TagLabel,
  TagCloseButton,
} from "@chakra-ui/react";

interface FilterTagProps {
  label: string;
  onRemove: () => void;
}

export default function FilterTag({ label, onRemove }: FilterTagProps) {
  return (
    <Tag
      size="sm"
      variant="solid"
      bg="cdsIndigo.400"
      color="white"
      borderRadius="md"
      pl="10px"
      pr="4px"
      h="21px"
      minH="21px"
    >
      <TagLabel
        fontFamily="Lato"
        fontWeight="500"
        fontSize="12px"
        lineHeight="16px"
        letterSpacing="0"
        mr="0"
      >
        {label}
      </TagLabel>
      <TagCloseButton
        onClick={onRemove}
        size="xs"
        color="white"
        opacity={1}
        ml="0"
        _hover={{ opacity: 0.8 }}
      />
    </Tag>
  );
}
